import { IntlShape } from 'react-intl';
import { MusicAPIIntegrationID } from 'fym-shared/src/music-services/ids';
import { presaveLibraryWriteServices } from 'fym-shared/src/smartlinks/presaveSubscriptions';
import { presaveSubscribeMessages } from './presaveSubscribeMessages';

/** The services of the block, in the order of the editor and of the page (design d6). */
export const PRESAVE_SUBSCRIBE_SERVICES: readonly string[] = [
  MusicAPIIntegrationID.Spotify,
  MusicAPIIntegrationID.AppleMusic,
  MusicAPIIntegrationID.Deezer,
  MusicAPIIntegrationID.AmazonMusic,
  MusicAPIIntegrationID.Tidal,
  MusicAPIIntegrationID.YoutubeMusic,
];

/** A new block offers every library service plus YouTube Music (email only for now, D13). */
export const DEFAULT_PRESAVE_SUBSCRIBE_SERVICES: string[] = [...PRESAVE_SUBSCRIBE_SERVICES];

/** True for a service whose fans get the email only: musicapi cannot write its library yet. */
export function isEmailOnlyService(integrationType: string): boolean {
  return !presaveLibraryWriteServices.includes(integrationType);
}

/** Adds or removes one service and keeps the editor order. */
export function toggleService(selected: readonly string[], integrationType: string): string[] {
  const next = selected.includes(integrationType)
    ? selected.filter((one) => one !== integrationType)
    : [...selected, integrationType];
  return PRESAVE_SUBSCRIBE_SERVICES.filter((one) => next.includes(one));
}

/** The grey line of the block in the rail: "3 services and email", or "Email only". */
export function presaveSubscribeBlockDetail(intl: IntlShape, services: readonly string[] | undefined): string {
  const count = (services ?? []).filter((one) => !isEmailOnlyService(one)).length;
  return count === 0
    ? intl.formatMessage(presaveSubscribeMessages.detailEmailOnly)
    : intl.formatMessage(presaveSubscribeMessages.detail, { count });
}
